export interface Location {
  x: number;
  y: number;
}

export interface FixedPaymentRate {
  paymentRate: number;
  paymentRateType: string;
}

export interface RangePaymentRate {
  max: number;
  min: number;
  paymentRateType: string;
}

export interface PaymentRate {
  fixedPaymentRate: FixedPaymentRate;
  rangePaymentRate: RangePaymentRate;
}
/* eslint-disable no-unused-vars */
export enum ScheduleTypes {
  REGULAR = 'regular',
  ONE_TIME = 'one-time',
  OCCASIONAL = 'occasional',
  NANNY = 'nanny',
}
/* eslint-enable no-unused-vars */
export type ScheduleType = `${ScheduleTypes}`;

export interface RegularJobSchedule {
  type: ScheduleTypes.REGULAR;
  days: string[];
  endTime: string;
  isStartDateFlexible: boolean;
  isStartTimeFlexible: boolean;
  startDate: string;
  startTime: string;
}

export interface OneTimeJobSchedule {
  type: ScheduleTypes.ONE_TIME;
  endTime: string;
  isStartTimeFlexible: boolean;
  startDate: string;
  startTime: string;
}

export interface OccasionalJobSchedule {
  type: ScheduleTypes.OCCASIONAL;
  isStartDateFlexible: boolean;
  startDate: string;
}

export interface NannyJobSchedule {
  type: ScheduleTypes.NANNY;
  employmentType: string;
  endTime: string;
  hours: number;
  isStartDateFlexible: boolean;
  isStartTimeFlexible: boolean;
  startDate: string;
  startTime: string;
}

export type Schedule = RegularJobSchedule | OneTimeJobSchedule | OccasionalJobSchedule | NannyJobSchedule;

export interface JobInput {
  title: string;
  activeUntil: string;
  ageGroups: string[];
  careType: string;
  description: string;
  requirements: string[];
  languages: string[];
  location: Location | null;
  numberOfChildren: number | null;
  paymentRate: PaymentRate | null;
  schedule: Schedule | null;
  aiGenerated: boolean;
}

export interface JobState {
  jobInput: JobInput;
}

export const state: JobState = {
  jobInput: {
    title: '',
    description: '',
    activeUntil: '',
    ageGroups: [],
    careType: '',
    requirements: [],
    languages: [],
    location: null,
    numberOfChildren: null,
    paymentRate: null,
    schedule: null,
    aiGenerated: false,
  },
};
